import { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../../../resources/images/svg/arrow.svg';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { localesWithFlags } from '../../../../utils/constants/locales';

function LanguageSelector() {
  const { currentLanguage, configInfo } = useContext(TranslationContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const close = () => {
    setOpen(false);
  };

  const handleChoose = (code) => {
    navigate(location.pathname.replace(
      `/${currentLanguage}`,
      `/${code.toLowerCase()}`,
    )
        + location.search);
    close();
  };

  const chosenCountry = localesWithFlags.find(({ code }) => code === currentLanguage);

  return (
    <div className="h-[42px]">
      <div className="relative w-fit px-[17px] py-[14px] flex flex-col justify-center bg-[#F1F2F6] rounded-lg  ease-in duration-300">
        <button
          type="button"
          className="flex gap-1 items-center text-gr-gray h-4 cursor-pointer bg-transparent border-0 p-0"
          onClick={() => setOpen((prev) => !prev)}
        >
          <img src={chosenCountry.imagePath} height={13} width={19} alt={chosenCountry.code} />
          <p className="m-0 text-base leading-4 font-sans">{chosenCountry.code.toUpperCase()}</p>
          <Arrow className={`ease-out duration-300 rotate-${open && '180'}`} />
        </button>
        <div className={`expander ${open && 'expanded'}`}>
          <div className="expander-content">
            {localesWithFlags
              ?.filter(({ code, allowedCountries }) => code !== currentLanguage
            && allowedCountries.includes(configInfo?.countryCode))?.map(({ code, imagePath }) => (
              <button
                key={code}
                type="button"
                className="flex gap-1 items-center text-gr-gray relative h-4 cursor-pointer mt-1 bg-transparent border-0 p-0"
                onClick={() => handleChoose(code)}
                onKeyDown={close}
              >
                <img src={imagePath} height={13} width={19} alt={code} />
                <p className="m-0 text-base leading-4 font-sans">{code.toUpperCase()}</p>
              </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LanguageSelector;
